import { useMemo } from 'react'
import { Meta, TableState } from 'react-table'

/**
 * plugin hooks for grouping that hides the grouped column so it won't show
 * in the table when there is grouping but instead aggregate them in a column.
 */
const useGroupingState = <TData extends Object>(
    state: TableState<TData>,
    _meta: Meta<TData>
) => {
    return useMemo(() => {
        if (state.groupBy.length) {
            return {
                ...state,
                hiddenColumns: [
                    ...(state.hiddenColumns ?? []),
                    ...state.groupBy,
                ].filter((d, i, all) => all.indexOf(d) === i),
            }
        }
        return state
    }, [state])
}

export default useGroupingState
